import { Component } from '@angular/core';

@Component({
    selector: 'ct-forbidden',
    templateUrl: 'forbidden.component.html',
    standalone: false
})

export class ForbiddenComponent {
}
